import React from 'react'

import { Box, LinearProgress, Typography } from "@mui/material"


export default function searchesHomeColumn() {

	return {
		name: 'searches',
		label: 'Number of searches',
		// a fixed track next to the figure: as 70% of a third of the cell it read as a dot
		render: (value, { percentage }) => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
			<Box sx={{ width: 80, flexShrink: 0 }}>
				<LinearProgress variant="determinate" value={Math.abs(percentage)}/>
			</Box>
			<Typography sx={{ fontWeight: "bold", color: "secondary.main", minWidth: 48 }}>{value}</Typography>
		</Box>
	}
}
